import AppLayout from "../AppLayout/AppLayout"
import { MSACCT_TITLE } from '../../Utilities/QueryBuilderConstants'
import BreadCrumbExtension, { IBreadCrumbExtension } from '../../Controls/BreadCrumbExtension/BreadCrumbExtension'
import PoliCheck from "../../PoliCheck/PoliCheck"

const breadcrumbItem: IBreadCrumbExtension[] = [
    { text: 'Home', key: 'Home', href: '/' },
    { text: 'Mini APPs', key: 'MiniApps' },
    { text: 'PoliCheck', key: 'f5' },
]

export default function PoliCheckPage() {

    document.title = MSACCT_TITLE + " | " + "PoliCheck";

    return (
        <AppLayout
        renderBreadcrumb={() =>
          <BreadCrumbExtension items={breadcrumbItem} />
        }
        renderContentPane={() => <PoliCheck/>} />
    )
}